import { SVGFC } from '@repo/toolkit/types'

const DownloadFile: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.4118 4H12.6366C15.3213 4 16.6653 4 17.5975 4.6384C17.8644 4.8208 18.1015 5.0384 18.3016 5.2824C19 6.1352 19 7.3624 19 9.8184V11.8544C19 14.2248 19 15.4104 18.6138 16.3568C17.9928 17.8792 16.6801 19.0792 15.0149 19.6472C13.9798 20 12.6844 20 10.0902 20C8.60953 20 7.86835 20 7.27706 19.7984C6.32588 19.4736 5.57565 18.788 5.22071 17.9184C5 17.3776 5 16.7 5 15.3456V12"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.9997 12C18.9997 12.7072 18.7105 13.3854 18.1958 13.8854C17.681 14.3855 16.9829 14.6664 16.2549 14.6664C15.7064 14.6664 15.06 14.5736 14.5271 14.712C14.2944 14.7728 14.0822 14.8919 13.9118 15.0575C13.7414 15.223 13.6188 15.4291 13.5562 15.6552C13.4137 16.1728 13.5092 16.8008 13.5092 17.3336C13.5092 17.6838 13.4382 18.0305 13.3003 18.354C13.1624 18.6775 12.9602 18.9714 12.7053 19.219C12.4504 19.4666 12.1478 19.663 11.8148 19.797C11.4818 19.931 11.1249 20 10.7644 20M5.82324 6C6.22842 5.5952 7.3056 4 7.88207 4M7.88207 4C8.45854 4 9.53571 5.5952 9.94089 6M7.88207 4V10.4"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default DownloadFile
